<template>
  <footer class="app-footer">
    <p class="app-footer__copyright">© 2024 {{ $t("brand.name") }}. {{ $t("footer.rights") }}</p>
    <p class="app-footer__made">made with 🐣</p>

    <div class="app-footer__biz">
      <p>
        <span>{{ $t("footer.contact") }} virtupet.official@gmail.com</span>
      </p>
    </div>

    <p class="app-footer__policy">
      <a :href="`/policy/terms.html?lang=${$i18n.locale}`" target="_blank" rel="noopener">{{ $t("footer.terms") }}</a>
      <span class="sep">|</span>
      <a :href="`/policy/privacy.html?lang=${$i18n.locale}`" target="_blank" rel="noopener">{{
        $t("footer.privacy")
      }}</a>
      <span class="sep">|</span>
      <a :href="`/policy/refunds.html?lang=${$i18n.locale}`" target="_blank" rel="noopener">{{
        $t("footer.refunds")
      }}</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style scoped>
.app-footer {
  text-align: center;
  color: #888;
  font-size: 12px;
  line-height: 1.6;
}

.app-footer__copyright {
  margin: 0;
  font-weight: 600;
  color: #777;
}

.app-footer__made {
  margin: 0 0 6px;
  color: #aaa;
}

.app-footer__biz p {
  margin: 0;
  color: #999;
}

.app-footer__biz .sep {
  margin: 0 6px;
  color: #ccc;
}

.app-footer__policy {
  margin: 6px 0 0;
}
.app-footer__policy a {
  color: #888;
  text-decoration: none;
  pointer-events: auto; /* 로그인 오버레이(.login-footer-overlay pointer-events:none) 안에서도 클릭되게 */
}
.app-footer__policy a:hover {
  text-decoration: underline;
}
.app-footer__policy .sep {
  margin: 0 6px;
  color: #ccc;
}

@media screen and (max-width: 600px) {
  .app-footer {
    font-size: 11px;
  }
  .app-footer__biz .sep {
    margin: 0 4px;
  }
}
</style>
